import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "order-block" }
const _hoisted_2 = { class: "order-products" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "order-note"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Poznámka:", -1)
const _hoisted_6 = {
  key: 2,
  class: "progress"
}

import { OrderDetailModel } from '@/types/Order';



export default /*#__PURE__*/_defineComponent({
  __name: 'StaffOrderItem',
  props: {
    order: null,
    showPercentage: { type: Boolean },
    percentage: null
  },
  setup(__props: any) {

const props = __props as {
    order: OrderDetailModel,
    showPercentage: boolean,
    percentage: number
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(__props.order.id), 1),
    _createElementVNode("h4", null, _toDisplayString(__props.order.total.toFixed(2)) + " Kč", 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.order.products, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          key: product.product.id
        }, [
          _createElementVNode("span", null, _toDisplayString(product.amount) + "x - " + _toDisplayString(product.product.name), 1)
        ]))
      }), 128))
    ]),
    (__props.order.note!='')
      ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
      : _createCommentVNode("", true),
    (__props.order.note!='')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", null, _toDisplayString(__props.order.note), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.order.isFinished && __props.showPercentage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "progress-bar bg-info",
            role: "progressbar",
            "aria-label": "Danger example",
            style: _normalizeStyle({width: __props.percentage*100 + '%'}),
            "aria-valuenow": "100",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }, null, 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})